import { useTranslation } from 'react-i18next'
import { localStorageVar } from '../constant'
import { getFromLocalStorage } from './useLocalStorage'

const LANGS = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'in',
    label: 'हिंदी',
  },
  {
    value: 'ml',
    label: 'മലയാളം',
  },
  {
    value: 'ta',
    label: 'தமிழ்',
  },
  {
    value: 'te',
    label: 'తెలుగు',
  },
  {
    value: 'kn',
    label: 'ಕನ್ನಡ',
  },
  {
    value: 'as',
    label: 'অসমীয়া',
  },
  {
    value: 'bn',
    label: 'বাংলা',
  },
  {
    value: 'gu',
    label: 'ગુજરાતી',
  },
  {
    value: 'mr',
    label: 'मराठी',
  },
  {
    value: 'or',
    label: 'ଓଡ଼ିଆ',
  },
  {
    value: 'pa',
    label: 'ਪੰਜਾਬੀ',
  },
]

export default function useLocales() {
  const { i18n, t } = useTranslation()
  const langStorage = getFromLocalStorage(localStorageVar.I18_LANG_VAR)
  const currentLang = LANGS.find((_lang) => _lang.value === langStorage)

  const handleChangeLanguage = (newlang) => {
    i18n.changeLanguage(newlang)
  }

  return {
    onChangeLang: handleChangeLanguage,
    t,
    currentLang,
    allLang: LANGS,
  }
}
